<template>
	<div id="app" v-cloak>
		<router-view></router-view>
		<div class="home font-3" @click="home" v-show="$route.path != '/' && isHome">返回首页</div>
	</div>
</template>
<script>
export default {
	name: 'App',
	data(){
		return {
			isHome:false
		}
	},
	created() {
		if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){
			document.querySelector('html').setAttribute('style', 'background: url(../img/ic25.png) top center; background-size: 100% 100%; height: auto;')
			this.isHome = false
		}else{
			document.querySelector('html').setAttribute('style', 'background: url(../img/ic20.jpg) no-repeat center; background-size: 100% 100%;')
			this.isHome = true
		}
    },
	methods:{
		home(){
			this.$router.push({ path:'/'});
		}
	}
}
</script>
<style>
@font-face {
    font-family: "font-1";
    src: url(../fonts/FZCYSJW.TTF);
}
@font-face {
    font-family: "font-2";
    src: url(../fonts/隶书.ttf);
}
@font-face {
    font-family: "font-3";
    src: url(../fonts/汉仪粗仿宋简.ttf);
}
@font-face {
    font-family: "font-4";
    src: url(../fonts/FZSKBXKK.TTF);
}
@font-face {
    font-family: "font-5";
    src: url(../fonts/方正特雅宋_GBK.TTF);
}
.font-1{
	font-family: 'font-1';
}
.font-2{
	font-family: 'font-2';
}
.font-3{
	font-family: 'font-3';
}
.font-4{
	font-family: 'font-4';
}
.font-5{
	font-family: 'font-5';
}
*,*:after,*::before{
	box-sizing:border-box;
	-ms-box-sizing:border-box;
	-moz-box-sizing:border-box;
	-webkit-box-sizing:border-box;
}
*{
	text-decoration:none;
	list-style:none;
	margin:0;
	padding:0;
	border:none;
	line-height: 1;
	font-weight:normal;
	font-size:.7rem;
}
[v-cloak]{
	display: none;
}
#app {
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	color: #2c3e50;
}
html,body{
	min-height: 100%;
}
.el-slider__runway{
	background: #c6af7b;
}
.el-slider__bar{
	background-color: #d7412a;
}
.el-slider__button{
	border-radius: 3px;
	border:none;
	background-color: #d7412a;
	width: 7px;
}
.home{
	background-color: #d7412a;
	writing-mode:tb-rl;
	color: #c6af7b;
	border-radius: .15rem;
	position: fixed;
	right: 0;
	width: 3rem;
	padding: .75rem 0;
	display: flex;
	align-items: center;
	bottom: 20%;
	font-size: 1.5rem;
	cursor: pointer;
}
</style>